/*eslint-disable */
import React, { Component, useEffect, useState } from "react";
import { Table, Grid, Icon, Button } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import { translate } from "react-i18next";
import BranchDeleteModal from "./branchDeleteModal";
import DeleteAxios from "../axiosComponent/delete";
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
import cogoToast from "cogo-toast";
import PreferredLocationEdit from "./preferredLocationEdit";
const PreferredLocation = (props) => {

    const[openAddModal, setAddModal] = useState(false)
    const[openDeleteModal, setDeleteModal] = useState(false)
    const[currentObject , setCurrentObject] = useState(null)
    const[mappingData, setMappingData] = useState(null)
    const[locationIds, setLocationIds] = useState([])

    const {t} = props

    useEffect(()=>{
        if(props.vendorId){
            getPreferredLocations(props.vendorId)
        }
    },[props.vendorId])

    const getPreferredLocations= (vendorId)=>{
      ReadAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/transporterPreferredLocations?vendorId=${vendorId}`
      }).then((res)=>{
        if(res?.data?.resultSet?.length){
          let location_ids = []
          res.data.resultSet.map((data)=>{
            location_ids.push(data.stateId)
          })
          setLocationIds(location_ids)
          setMappingData(res?.data?.resultSet)
        }
      })
    }

    const openModal = (type, data)=>{
        if(type == "add"){
            setAddModal(true)
        }else{
            setDeleteModal(true)
        }
        setCurrentObject(data)
    }

    const closeModal = ()=>{
        setAddModal(false)
        setDeleteModal(false)
        setCurrentObject(null)
    }

    const confirmDelete = ()=>{
      DeleteAxios({
        url: `transporterPreferredLocations`,
        uniqueId: currentObject?.vendorStateMappingId
      }).then((res)=>{
        if(res?.data?.status == 200){
          cogoToast.success(res?.data?.message, {hideAfter : 2,position: "top-right"});
          window.location.reload()
        }
      }).catch((err)=>{
        console.log(err);
      })
    }
  
    return (
      <>
        {true && (
          <div>
            <Table stackable size="small" selectable>
              <Table.Header className="w3-small">
                <Table.Row>
                  <Table.HeaderCell colSpan="2" className="p-bold-600">
                    {t('preferred_locations.title')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-600" textAlign="right">
                    <Button
                      type="button"
                      className="w3-button w3-blue w3-small w3-round w3-hover-blue"
                      add_mode="add"
                      onClick={()=> openModal("add", null)}
                    >
                      <Icon name="plus" /> {t('preferred_locations.add_title')}
                    </Button>
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className="p-bold-500" colSpan="2">
                  {t("preferred_locations.table_header.location")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                      {t('preferred_locations.table_header.delete') || 'Delete'}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              {mappingData && mappingData.length > 0 ? (
                mappingData.map((object, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>{object.state ? object.state : "NA"}</Table.Cell>
                  <Table.Cell><Button type="button" onClick={()=> openModal("delete", object)} size="mini" color="blue" basic icon> <Icon name="trash" /> </Button></Table.Cell>
                  </Table.Row>
                ))
              ) : (
                <Table.Row>
                  <Table.Cell colSpan="6">{t("preferred_locations.no_records" || "No Record(s) Found")}</Table.Cell>
                </Table.Row>
              )}
            </Table>
          </div>
        )}
        <BranchDeleteModal
          deleteOpen={openDeleteModal}
          CloseModal={closeModal}
          ConfirmDeleteRow={confirmDelete}
        />
        <PreferredLocationEdit
          vendorId={props.vendorId}
          openModal={openAddModal}
          CloseModal={closeModal}
          locationIds={locationIds}
          rest
        />
      </>
    );
}

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate('create_vendor')(PreferredLocation));
